// extracted by mini-css-extract-plugin
export var adress = "contact-card-module--adress--24419";
export var affliation = "contact-card-module--affliation--bee49";
export var axeLink = "contact-card-module--axeLink--d8519";
export var containerAll = "contact-card-module--containerAll--7e8b7";
export var detach = "contact-card-module--detach--e9631";
export var email = "contact-card-module--email--7cb45";
export var infoContainer = "contact-card-module--infoContainer--54509";
export var linkInfo = "contact-card-module--linkInfo--86d00";
export var name = "contact-card-module--name--0f47b";
export var number = "contact-card-module--number--3bffa";
export var office = "contact-card-module--office--76726";
export var organization = "contact-card-module--organization--1955e";
export var profileImage = "contact-card-module--profileImage--a09ff";
export var researcherPage = "contact-card-module--researcherPage--1b57b";
export var researcherPageRelated = "contact-card-module--researcherPageRelated--27f1f";
export var root = "contact-card-module--root--80ad0";
export var searchContainer = "contact-card-module--searchContainer--ae561";
export var theme = "contact-card-module--theme--ffdda";
export var title = "contact-card-module--title--39e14";
export var titleencadre = "contact-card-module--titleencadre--a240a";
export var underline = "contact-card-module--underline--e59ab";